// 2026-05-17 SEO L2: intent-specific landing pages targeting the
// non-branded gift-voucher queries where Bongo, Hotelgiftcard,
// Cadeaubon.nl and Secret Escapes currently win. Each intent picks
// a slice of /vouchers filtered by category_id, plus its own H1,
// intro paragraph, FAQ set and meta-tags so Google and LLM crawlers
// see a tightly-scoped page instead of redirecting all "weekendje
// weg cadeau" traffic to the generic /vouchers index.
//
// Translation keys live in src/i18n/nl.json under cadeaubon.<intent>.*.
// DE/FR/EN equivalents follow in L2.5 once NL impact is measurable.
//
// Fixronde 3 #1920: the copy names no amount. Meta title, meta description,
// intro and the price question (faq_price) name the lowest price of the
// vouchers in the hub (filterVouchersForIntent, via hub-price.js, the same
// price rule as the voucher page and the checkout), and no amount when that
// set is empty or the list fails.

export const INTENT_LANDINGS = {
  "weekendje-weg": {
    slug: "weekendje-weg",
    path: "/cadeaubon/weekendje-weg",
    // Category filter: every voucher except theme-park stays counts as
    // a weekendje-weg candidate. Theme park stays are short experience
    // bundles, not a relaxation weekend.
    categoryFilter: ["wellness", "city_trip", "kasteelervaring"],
    i18nNs: "cadeaubon.weekendje_weg",
    breadcrumbName: "Weekendje weg cadeau",
    faqKeys: [
      "cadeaubon.weekendje_weg.faq_what.q",
      "cadeaubon.weekendje_weg.faq_what.a",
      "cadeaubon.weekendje_weg.faq_who.q",
      "cadeaubon.weekendje_weg.faq_who.a",
      "cadeaubon.weekendje_weg.faq_price.q",
      "cadeaubon.weekendje_weg.faq_price.a",
      "cadeaubon.weekendje_weg.faq_validity.q",
      "cadeaubon.weekendje_weg.faq_validity.a",
      "cadeaubon.weekendje_weg.faq_redeem.q",
      "cadeaubon.weekendje_weg.faq_redeem.a",
    ],
  },
  wellness: {
    slug: "wellness",
    path: "/cadeaubon/wellness",
    categoryFilter: ["wellness"],
    i18nNs: "cadeaubon.wellness",
    breadcrumbName: "Wellness cadeaubon",
    faqKeys: [
      "cadeaubon.wellness.faq_what.q",
      "cadeaubon.wellness.faq_what.a",
      "cadeaubon.wellness.faq_who.q",
      "cadeaubon.wellness.faq_who.a",
      "cadeaubon.wellness.faq_resorts.q",
      "cadeaubon.wellness.faq_resorts.a",
      "cadeaubon.wellness.faq_validity.q",
      "cadeaubon.wellness.faq_validity.a",
      "cadeaubon.wellness.faq_redeem.q",
      "cadeaubon.wellness.faq_redeem.a",
    ],
  },
  stedentrip: {
    slug: "stedentrip",
    path: "/cadeaubon/stedentrip",
    categoryFilter: ["city_trip"],
    i18nNs: "cadeaubon.stedentrip",
    breadcrumbName: "Stedentrip cadeaubon",
    faqKeys: [
      "cadeaubon.stedentrip.faq_what.q",
      "cadeaubon.stedentrip.faq_what.a",
      "cadeaubon.stedentrip.faq_destinations.q",
      "cadeaubon.stedentrip.faq_destinations.a",
      "cadeaubon.stedentrip.faq_who.q",
      "cadeaubon.stedentrip.faq_who.a",
      "cadeaubon.stedentrip.faq_validity.q",
      "cadeaubon.stedentrip.faq_validity.a",
      "cadeaubon.stedentrip.faq_redeem.q",
      "cadeaubon.stedentrip.faq_redeem.a",
    ],
  },
  pretparken: {
    slug: "pretparken",
    path: "/cadeaubon/pretparken",
    categoryFilter: ["pretparken"],
    i18nNs: "cadeaubon.pretparken",
    breadcrumbName: "Themapark cadeaubon",
    faqKeys: [
      "cadeaubon.pretparken.faq_what.q",
      "cadeaubon.pretparken.faq_what.a",
      "cadeaubon.pretparken.faq_parks.q",
      "cadeaubon.pretparken.faq_parks.a",
      "cadeaubon.pretparken.faq_who.q",
      "cadeaubon.pretparken.faq_who.a",
      "cadeaubon.pretparken.faq_validity.q",
      "cadeaubon.pretparken.faq_validity.a",
      "cadeaubon.pretparken.faq_redeem.q",
      "cadeaubon.pretparken.faq_redeem.a",
    ],
  },
};

// 2026-05-19 L2.5: the 4 main hubs now have localized content in
// DE/FR/EN authored from local-persona perspective. Each hreflang
// pair points at the SAME slug across all markets — the localized
// copy lives in the i18n bundle keyed by cadeaubon.<intent>.*. Non-NL
// /cadeaubon/<intent> URLs are now indexable (no longer noindex).
// Translation coverage applies to the 4 main hubs only; branded voucher
// landings (Veluwse Bron etc.) stay NL-only because those brands have
// no equivalent on the DE/FR/UK markets.
export const CADEAUBON_ALTERNATE_PATHS = {};

export function filterVouchersForIntent(vouchers, intent) {
  if (!Array.isArray(vouchers) || !intent) return [];
  const allowed = new Set(intent.categoryFilter);
  return vouchers.filter((v) => allowed.has(v?.category_id));
}
